import React, { useCallback, useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { Table } from "antd";
// import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { viewBuilderList } from "../../Redux/Actions/builderActions";
import "./listBuilder.css";
// import axios from "axios";
import LineGraph from "./lineGraph";
import { columnsBuilders } from "../../Global Functions/columnsAntd";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";
import ListTopSearch from "../../Global Functions/listTopSearch";

const ListBuilders = () => {
  // const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");

  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);


  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const fetchDetails = useCallback(async (page, pageSize, showLoader = true) => {
    const builderData = {
      page,
      limit: pageSize,
      is_deleted: false,
      filter: debouncedSearch,
      business_type: "fresh",
      // signup_from: "builder_panel",
      ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
      ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
    };

    try {
      await dispatch(viewBuilderList(builderData, showLoader));

      if (!showLoader) {
        toast.success("Bookings list refreshed");
      }
    } catch {
      if (!showLoader) {
        toast.error("Failed to refresh bookings list");
      }
    }
  },
    [dispatch, debouncedSearch, dateRange]
  );

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDetails, pagination.current, pagination.pageSize]);

  const { builders, loading } = useSelector((state) => state.builders);

  useEffect(() => {
    if (builders?.total) {
      setPagination((prevData) => ({ ...prevData, total: builders.total }));
    }
  }, [builders]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    // fetchDetails(pagination.current, pagination.pageSize);
  };

  // const graphOptions = ["year", "month", "week"];
  // const [graphData, setGraphData] = useState({});

  // const [graphSelect, setGraphSelect] = useState({ type: "year" });

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  // useEffect(() => {
  //   const selectionGetGraphDataHandler = async (event) => {
  //     try {
  //       const response = await axios.post(
  //         `${BASE_URL}/builder/graph`,
  //         graphSelect,
  //         {
  //           headers: { "Content-Type": "application/json" },
  //         }
  //       );
  //       if (response) {
  //         setGraphData(response.data.data);
  //       }
  //     } catch (error) {
  //       console.error("Error Loading Graph Data");
  //     }
  //   };
  //   selectionGetGraphDataHandler();
  // }, [dispatch, graphSelect, BASE_URL]);

  return (
    <MainLayout>
      <div className="dashboard-container">
        <div className="topbar-containers">
          {/* <div className="total_builder">
            <h1 style={{ marginTop: "30px" }}>Total Builders</h1>
            <h1 style={{ fontSize: "80px", marginTop: "50px" }}>
              {builders?.total}
            </h1>
          </div> */}
          <div className="builder_graph" style={{ height: "96%"}}>
            {/* <div className="builder_graph_div">
              <h1>Total Builders Graph</h1>
              <select
                style={{ cursor: "pointer" }}
                name=""
                id=""
                onChange={(event) =>
                  setGraphSelect((prevData) => ({
                    ...prevData,
                    type: event.target.value,
                  }))
                }
              >
                <option disabled selected hidden value="">
                  Year
                </option>
                {Array.isArray(graphOptions) &&
                  graphOptions.map((option, index) => (
                    <option key={index} value={option}>
                      {option?.charAt(0)?.toUpperCase() + option.slice(1)}
                    </option>
                  ))}
                {graphData && graphData.length > 0 && <LineGraph graphData={graphData} />}
              </select>
            </div> */}
            <LineGraph />
          </div>
          <div className="recently_added">
            <div className="overall_added">
              <div className="h3andbutton">
                <h3>
                  Recently Added{" "}
                  <span className="new_badge">
                    {builders?.recent_builders?.length || 0} new
                  </span>
                </h3>
              </div>
              <div className="builder_lists">
                {Array.isArray(builders?.recent_builders) &&
                  builders.recent_builders.map((builder, index) => {
                    const gradients = [
                      "linear-gradient(135deg, #B5D4F4, #378ADD)",
                      "linear-gradient(135deg, #9FE1CB, #1D9E75)",
                      "linear-gradient(135deg, #F5C4B3, #D85A30)",
                      "linear-gradient(135deg, #CECBF6, #7F77DD)",
                      "linear-gradient(135deg, #FAC775, #BA7517)",
                    ];
                    const initials = (builder?.brand_name || "?").charAt(0).toUpperCase();
                    const gradient = gradients[index % gradients.length];
                    const formattedDate = builder?.created_at
                      ? new Date(builder.created_at).toLocaleDateString("en-US", {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                      })
                      : "No Date";

                    return (
                      <div className="builder_item" key={builder._id || index}>
                        <div className="builder_item_left">
                          <div className="builder_avatar_wrapper">
                            {builder?.profile_image ? (
                              <img
                                className="profile_image"
                                src={builder.profile_image}
                                alt="Profile"
                                onError={(e) => {
                                  e.target.style.display = "none";
                                  e.target.nextSibling.style.display = "flex";
                                }}
                              />
                            ) : null}
                            <div
                              className="avatar_initials"
                              style={{
                                background: gradient,
                                display: builder?.profile_image ? "none" : "flex",
                              }}
                            >
                              {initials}
                            </div>
                            <span className="builder_status_dot" />
                          </div>
                          <div className="builder_info">
                            <span className="builder_name">
                              {builder?.brand_name || "No Data"}
                            </span>
                            <p className="builder_date">Added {formattedDate}</p>
                          </div>
                        </div>

                        <div className="brand_tile">
                          {builder?.brand_logo ? (
                            <img
                              src={builder.brand_logo}
                              alt="Brand"
                              className="brand_tile_img"
                              onError={(e) => {
                                e.target.style.display = "none";
                                e.target.nextSibling.style.display = "block";
                              }}
                            />
                          ) : null}
                          <span
                            className="brand_tile_text"
                            style={{ display: builder?.brand_logo ? "none" : "block" }}
                          >
                            {builder?.brand_name?.slice(0, 8) || "No brand"}
                          </span>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>

        <div className="table_component_all">
          <ListTopSearch
            buttonhead={canAdd ? "Add Builder" : null}
            navigateTo={canAdd ? "/builders/add" : null}
            h3heading="Builders List"
            setState={setSearchQuery}
            onCalendarClick={() => setIsDatePopupVisible(true)}
          ></ListTopSearch>
          <div style={{ overflowX: "auto", padding: "0px 60px" }}>
            <Table
              dataSource={Array.isArray(builders?.data) ? builders.data : []}
              pagination={pagination}
              scroll={{ x: 1700, y: 500 }}
              onChange={handleTableChange}
              loading={loading}
              columns={columnsBuilders}
              rowClassName={() => "text-center"}
            ></Table>
          </div>
        </div>
        <DateRangePopup
          visible={isDatePopupVisible}
          initialStart={dateRange.start}
          initialEnd={dateRange.end}
          onCancel={() => setIsDatePopupVisible(false)}
          onOk={handleDateRangeApply}
        />
      </div>
    </MainLayout>
  );
};

export default ListBuilders;
